import fromExponential from 'from-exponential';

import { PID_OUTPUT_LABEL } from '@/helpers/unit-formatter/shared/constants';
import { FormattedUnitLabels, NumericFormatterInput } from '@/helpers/unit-formatter/shared/types';
import {
  formatTwoNonZeroDecimals,
  unitValueToFormattedUnitLabels,
} from '@/helpers/unit-formatter/shared/utils';

/**
 * PID display formatter. Non-numeric passthrough is handled by
 * `asPassthroughNonNumericFormatter` at registry build.
 */
export const formatPid = ({ value }: NumericFormatterInput): FormattedUnitLabels => {
  let formattedValue: number | string = value;

  if (!Number.isInteger(value)) {
    const numDecimals = String(fromExponential(value)).split('.')[1]?.length || 0;

    if (numDecimals > 5) {
      if (Math.abs(value) < 0.000001 && Math.abs(value) > 0) {
        formattedValue = formatTwoNonZeroDecimals(value);
      } else {
        formattedValue = Number(value.toFixed(6));
      }
    }
  }

  return unitValueToFormattedUnitLabels({ value: formattedValue, units: PID_OUTPUT_LABEL });
};
